module.exports = __webpack_public_path__ + "img/ic_check_checkbox.20789265.svg";